import state from './healthcheck.state'
import mutations from './healthcheck.mutations'
import actions from './healthcheck.actions'

export default {
  state,
  mutations,
  actions
}
